import React, { useEffect, useState } from "react";
import {
  Outlet,
  useNavigate,
  useLocation,
  NavLink,
  Link,
} from "react-router-dom";
import { connect } from "react-redux";
import { Loading, SelectedCampaign } from "../../../redux/action";
import { PublicService, LocalService, CommonService, ListService } from "../../../core/services";
import "./main-campaign-details.scss";
// import * as Crypto from 'crypto-js';
import { UserReducer } from "../../../redux/reducer/reducer";
import Popper from '@mui/material/Popper';
import Box from '@mui/material/Box';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { XIcon } from 'react-share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Methods } from '../../../core/utility';
import { InfluencerProposalChat } from '../my-campaign/influencer-chat';
import CampaignDetailTitle from './campaign-detail/campaign-detail-title';
import * as gtUtil from "../../../core/utility"
import { isMobile, isTablet, isBrowser } from 'react-device-detect';
import useBodyClass from "../../../hooks/useBodyClass";
import MaterialSymbol from "../../../components/icons/material-symbol";
import { IconButton } from "@mui/material";
import { Share } from "lucide-react";
import CustomDrawer from "../../../components/custom-drawer/custom-drawer";
import { ImShare } from "react-icons/im";


const methods = new Methods();
interface Props {
  UserReducer: any;
  selectCampaign: any;
  loading: (data: any) => void;
  selectedInf: (data: any) => void;
}

const localService = new LocalService();
const publicService: PublicService = new PublicService();
const commonService: CommonService = new CommonService();
const listService: ListService = new ListService();

const InfluencerMainCampDetail: React.FC<Props> = (props: Props) => {
  const [params, setParams] = useState("");
  const [currentCampaign, setCurrentCampaign] = useState<any>(null);
  const [showElement, setShowElement] = useState(false);
  // const getParams = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [campaignPopperState, setCampaignPopperState] = useState<{
    [key: string]: boolean;
  }>({});
  const [anchorEls, setAnchorEls] = useState<HTMLElement | null>(null);
  const [selectedCampaign, setSelectedCampaign] = useState<any | null>(null);
  const [shareUrl, setShareUrl] = useState('');
  const [applyButtonClass, setApplyButtonClass] = useState('Apply Now');
  const [disabledApplyBtn, setDisabledApplyBtn] = useState<boolean>(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);
  const [resStatus, setResStatus] = useState()
  const [showChat, setShowChat] = useState<boolean>(false);
  const [tokenParams ,setTokenParams] = useState(null);
  useEffect(() => {
    getCampaignDetailsPage();
  }, []);
const getParams = new URLSearchParams(location.search);

  // Determine device type
  let device = 'laptop'; // default
  if (isMobile) {
    device = 'mobile';
  } else if (isTablet) {
    device = 'tablet';
  } else if (isBrowser) {
    device = 'laptop';
  }

let proposalId = props?.selectCampaign?.proposalId;
  async function getCampaignDetailsPage() {
    try {

      if (props?.selectCampaign?.campaign_id) {
        setParams(`${props?.selectCampaign.campaign_id}`);
      }
      const getParams = new URLSearchParams(location.search);
      // let campaign_key = getParams.get('campaign_key')||'';
      let sm_id = getParams.get('smId');
      let key = getParams.get('key');
      let isShare = getParams.get('isShare');
      let campaign_id = getParams.get('campaignId');
      let platform = getParams.get('platform');
      if (isShare === 'true') {
        sm_id = '0';
        props.UserReducer.influencer_ids.find((data: any) => {
          if (platform === 'Instagram' && data.platform_type === 'Instagram') {
            sm_id = data.ig_id;
            return;
          }

          if (platform === 'Youtube' && data.platform_type === 'Youtube') {
            sm_id = data.yt_id;
            return;
          }
        });

        key = null;
      }
      if (key) {
        getCampaignDetails(decodeURI(key), null, null);
      } else if (campaign_id && sm_id) {
        getCampaignDetails(null, campaign_id, sm_id);
      } else {
        //if query params are not have influencer_id then return the dashboard if user is authenticated if user is public then return the login Page
      }
    } catch (error) {
      console.error('Error in getCampaignDetailsPage:', error);
    }
  }

  async function getCampaignDetails(
    key: string | null,
    campaign_id: string | null,
    sm_id: string | null,
    proposal_id?: string | null
  ) {
    try {
      let _QueryParams = "";
      let _Navigate = '';
      props.loading(true);
      if (key && key.length < 100) {
        const validateKey: any = await commonService.isValidKey({ key: key });

        if (validateKey.status === gtUtil.Constants.SUCCESS) {
          key = validateKey.data.rows[0].token;
          setTokenParams(validateKey.data.rows[0].token)        
        }
        else{
          setTokenParams(null)
        }
      };
      let response: any = await publicService.influencerCampaignDetail(key, campaign_id, sm_id, device);
      if (response.data.status.status) {
        setCurrentCampaign({ campaign: response.data.rows });
        props.selectedInf({ campaign: response.data.rows });
        setShowElement(true);

        //set route path
        if (key !== null) {
          _Navigate = `${location.pathname}?key=${key}`;
          _QueryParams = `key=${key}`;
        } else if (campaign_id !== null && sm_id !== null) {
          _Navigate = `${location.pathname}?campaignId=${response.data.rows.campaign_id}&smId=${sm_id}`;
          _QueryParams = `campaignId=${response.data.rows.campaign_id}&smId=${sm_id}`;
        }
        //set navigate
        navigate(_Navigate);
        //set the params
        setParams(_QueryParams);
      } else {
        setShowElement(false);
      };



    } catch (error) {
      throw new Error(
        `Get campaign details failed: function(getCampaignDetails :: Component ==> main-campaign-details)  ${JSON.stringify(
          error
        )}`
      );
    } finally {
      props.loading(false);
    }
  }

  async function handleClickShare(
    event: React.MouseEvent<HTMLElement>,
    res: any
  ) {
    try {
      document
        .getElementsByTagName('body')[0]
        .classList.add('custom-drawer-active');
      setAnchorEls(event.currentTarget);
      setSelectedCampaign(res);
      setCampaignPopperState((prev) => ({
        ...prev,
        [res.campaign_id]: !prev[res.campaign_id],
      }));
      setShareUrl(`${window.location.origin}/influencer/campaign/campaigndetails?campaignId=${res.campaign_id}&platform=${res.campaign_platform}&isShare=true`);
    } catch (error) {
      console.log('handleClickShare error ::', error);
    }
  };

    const handleCustomDrawerClose = () => {
      setSelectedCampaign(null);
      setCampaignPopperState({});
      
      document
        .getElementsByTagName('body')[0]
        .classList.remove('custom-drawer-active');
    };



  useEffect(() => {
    const fetchData = async () => {
      try {
        props.loading(true);
        const res = await listService.get_applied_campaigns({
          influencerId: props?.UserReducer?.influencer_id || props.selectCampaign.influencerId,
          campaignId: props?.selectCampaign?.campaign_id
        });
        if (res.status === -33) {
          setResStatus(res.status);
        } else if (res?.data?.status) {
          res.data.rows.find((element: any) => {
            setResStatus(res.status);
            if (element.campaign_id === props?.selectCampaign?.campaign_id) {
              if (element.status === 'Accepted' || element.status === 'Rejected') {
                // setDisabledApplyBtn(true);
                setApplyButtonClass(element.status);
              }

              if (element.status === 'Negotiating' || element.status === 'Pending' || element.status === 'Shortlisted') {
                // setDisabledApplyBtn(false);
                setApplyButtonClass('Applied');
              }

              setShowChat(true);
            }
          });
        }
      } catch (error) {
        console.warn('Influencer applied campaign List Error :: ' + error);
      } finally {
        props.loading(false);
      }
    };

    fetchData();
  }, [props, location.pathname, resStatus, disabledApplyBtn]);

  async function applyCampaign() {
    try {
      let generateUrl = Object.entries(methods._GetQueryParams(window.location.search)).map(([k, v]) => `${k}=${v}`).join('&');
      navigate(`/influencer/campaign/proposal?${generateUrl}`);

    } catch (error) {
      throw new Error(
        `applyCampaign function in campaign-details.tsx :: ${error}`
      );
    }
  }
  async function applyWithSignUp() {
    try {
      navigate(`/signup/influencer`, { state: { influencer_id: props.selectCampaign.influencerId } });
    } catch (error) {
      throw new Error(
        `applyCampaign function in campaign-details.tsx :: ${error}`
      );
    }
  }
  async function copyToClipboard() {
    let postUrl = shareUrl;
    navigator.clipboard.writeText(postUrl);
    localService.toastify('Link Copy', 'success', 1000);
  };
  useBodyClass('my-campaign-detail-page')
  useBodyClass('influencer-app')
  return (
    <>
      {showElement && (
        <div className="creative-w-sidebar">  
          {props.UserReducer != null && showChat && <InfluencerProposalChat/>}
          <div className="sidebar-content-sec">
            {device === "mobile" && (
              <div className="mobile-header d-md-none">
                <Link to="/influencer/mycampaigns">
                  <MaterialSymbol iconName="chevron_left" fontweight="400" fontSize="36px" />
                </Link>
                <span className="fw-bold text-[22px]">{currentCampaign?.campaign?.campaign_title}</span>
                <span className="share-icon" onClick={(event)=>handleClickShare(event, currentCampaign?.campaign)}>
                  <ImShare style={{fontSize:'28px', fontWeight:300}} />
                </span>                
              </div>
            )}
            <div className='main-campaign-det'>
              
              {(device !== "mobile" && resStatus !== -33) && (
                <>
                  <CampaignDetailTitle campaignDetail={currentCampaign.campaign} applyButtonClass={applyButtonClass} disabledApplyBtn={disabledApplyBtn} userReducer={props.UserReducer} applyCampaign={applyCampaign} handleOpen={handleOpen} />
                </>


              )}
              {resStatus !== -33 && (
                <nav className="sidebar-nav w-100">
                  {/* <MobileMenu params={params} /> */}
                  <NavLink className="sidebar-nav-link" to={`campaigndetails?${params}`}>
                    <span className='sidebar-nav-link-icon'><svg width="36" height="28" viewBox="0 0 36 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M29.5 14.8111V13.1893H35.5448V14.8111H29.5ZM31.6181 27.3431L26.765 23.7211L27.7725 22.4433L32.6256 26.0654L31.6181 27.3431ZM27.6717 5.4022L26.6643 4.12441L31.4707 0.509766L32.4782 1.78756L27.6717 5.4022ZM5.68906 25.4265V18.1284H3.25633C2.49254 18.1284 1.83473 17.8525 1.28289 17.3006C0.731014 16.7487 0.455078 16.0909 0.455078 15.3271V12.6732C0.455078 11.9094 0.731014 11.2516 1.28289 10.6998C1.83473 10.1479 2.49254 9.87196 3.25633 9.87196H10.7019L18.2948 5.37518V22.6252L10.7019 18.1284H7.31085V25.4265H5.68906ZM16.673 19.7477V8.25262L11.1466 11.4938H3.25633C2.96149 11.4938 2.69119 11.6166 2.44544 11.8623C2.19972 12.1081 2.07687 12.3784 2.07687 12.6732V15.3271C2.07687 15.622 2.19972 15.8923 2.44544 16.138C2.69119 16.3837 2.96149 16.5066 3.25633 16.5066H11.1466L16.673 19.7477ZM21.6858 19.5364V8.46393C22.3272 9.05861 22.8438 9.83941 23.2358 10.8063C23.6277 11.7733 23.8237 12.8379 23.8237 14.0002C23.8237 15.1625 23.6277 16.2271 23.2358 17.194C22.8438 18.1609 22.3272 18.9417 21.6858 19.5364Z" fill="#1C1B1F" />
                    </svg>
                    </span>
                    <span className='sidebar-nav-link-text'><span  className="d-md-none">Details</span><span className="d-none d-md-block">Campaign Detail</span></span></NavLink>
                  <NavLink className="sidebar-nav-link" to={`proposal?${params}`}>
                    <span className='sidebar-nav-link-icon'><svg width="21" height="26" viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.3903 20.6827H15.6099V19.484H5.3903V20.6827ZM5.3903 14.907H15.6099V13.7083H5.3903V14.907ZM2.42314 25.75C1.82578 25.75 1.32121 25.55 0.909425 25.15C0.497641 24.75 0.291748 24.2598 0.291748 23.6795V2.32049C0.291748 1.7402 0.497641 1.25005 0.909425 0.85003C1.32121 0.45001 1.82578 0.25 2.42314 0.25H14.3759L20.7084 6.40159V23.6795C20.7084 24.2598 20.5025 24.75 20.0907 25.15C19.679 25.55 19.1744 25.75 18.577 25.75H2.42314ZM13.7589 6.96645V1.44871H2.42314C2.19877 1.44871 1.99311 1.53952 1.80615 1.72114C1.6192 1.90276 1.52572 2.10254 1.52572 2.32049V23.6795C1.52572 23.8975 1.6192 24.0972 1.80615 24.2789C1.99311 24.4605 2.19877 24.5513 2.42314 24.5513H18.577C18.8014 24.5513 19.0071 24.4605 19.194 24.2789C19.381 24.0972 19.4744 23.8975 19.4744 23.6795V6.96645H13.7589Z" fill="#1C1B1F" />
                    </svg>
                    </span>
                    <span className='sidebar-nav-link-text'>Status</span>
                  </NavLink>
                  <NavLink className="sidebar-nav-link" to={`creative?${params}`}>
                    <span className='sidebar-nav-link-icon'>
                      <svg width="25" height="25" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.45561 29.8788C3.28207 29.8788 3.10499 29.8655 2.9279 29.8423C1.51125 29.6401 0.367296 28.569 0.151256 27.2427C-0.0116598 26.2579 0.314171 25.2896 1.04021 24.58C1.29166 24.3346 1.42979 24.0097 1.42979 23.6582V6.3459C1.42979 5.99442 1.29166 5.66946 1.04021 5.42409C0.314171 4.71448 -0.0116598 3.74624 0.151256 2.76142C0.370838 1.43175 1.51125 0.36403 2.9279 0.158445C3.97977 0.00922953 5.01393 0.310976 5.77184 0.99405C6.03393 1.22948 6.38101 1.3588 6.75642 1.3588H25.2438C25.6192 1.3588 25.9663 1.22948 26.2284 0.99405C26.9863 0.314292 28.0204 0.00922953 29.0723 0.158445C30.489 0.360714 31.6329 1.43175 31.849 2.75811C32.0119 3.74293 31.686 4.71117 30.96 5.42077C30.7086 5.66615 30.5704 5.9911 30.5704 6.34259V23.6516C30.5704 24.003 30.7086 24.328 30.96 24.5734C31.686 25.283 32.0119 26.2512 31.849 27.236C31.6294 28.5657 30.489 29.6334 29.0723 29.839C28.024 29.9882 26.9863 29.6865 26.2284 29.0034C25.9663 28.768 25.6192 28.6387 25.2438 28.6387H6.75642C6.38101 28.6387 6.03393 28.768 5.77184 29.0034C5.14143 29.5737 4.31977 29.8788 3.45561 29.8788ZM3.45207 1.44833C3.34936 1.44833 3.24665 1.45496 3.14394 1.47154C2.34353 1.5876 1.67416 2.2143 1.5502 2.96369C1.45812 3.53403 1.64229 4.09773 2.06374 4.50558C2.5702 4.99965 2.84645 5.65288 2.84645 6.3459V23.6549C2.84645 24.3512 2.56666 25.0044 2.06374 25.4952C1.64583 25.9031 1.45812 26.4668 1.5502 27.0371C1.67416 27.7865 2.34353 28.4132 3.14394 28.5292C3.75311 28.6155 4.35519 28.443 4.79081 28.0484C5.31851 27.5743 6.01622 27.3156 6.75642 27.3156H25.2438C25.9875 27.3156 26.6852 27.5776 27.2094 28.0484C27.645 28.4397 28.2436 28.6155 28.8563 28.5292C29.6567 28.4132 30.3261 27.7865 30.45 27.0371C30.5421 26.4668 30.3579 25.9031 29.9365 25.4952C29.43 25.0011 29.1538 24.3479 29.1538 23.6549V6.3459C29.1538 5.64957 29.4336 4.99634 29.9365 4.50558C30.3544 4.09773 30.5421 3.53403 30.45 2.96369C30.3261 2.2143 29.6567 1.5876 28.8563 1.47154C28.2436 1.38201 27.645 1.55775 27.2094 1.95234C26.6817 2.42652 25.984 2.68516 25.2438 2.68516H6.75642C6.01267 2.68516 5.31497 2.4232 4.79081 1.95234C4.42602 1.62407 3.95144 1.44833 3.45207 1.44833Z" fill="black" />
                        <path d="M24.5708 24.6031H7.42923C6.50132 24.6031 5.74341 23.8968 5.74341 23.0248V6.97583C5.74341 6.10706 6.49778 5.39746 7.42923 5.39746H24.5708C25.4987 5.39746 26.2566 6.10375 26.2566 6.97583V23.0248C26.2566 23.8935 25.4987 24.6031 24.5708 24.6031ZM7.42923 6.06064C6.8909 6.06064 6.45174 6.47181 6.45174 6.97583V23.0248C6.45174 23.5288 6.8909 23.9399 7.42923 23.9399H24.5708C25.1091 23.9399 25.5483 23.5288 25.5483 23.0248V6.97583C25.5483 6.47181 25.1091 6.06064 24.5708 6.06064H7.42923Z" fill="black" />
                        <path d="M22.6828 24.6031C22.573 24.6031 22.4668 24.5567 22.396 24.4672L14.6327 14.4963C14.4733 14.294 14.2289 14.168 13.9598 14.1548C13.6871 14.1415 13.4321 14.241 13.2514 14.4267L6.3594 21.4829C6.22836 21.6188 6.00523 21.6288 5.86003 21.5028C5.71482 21.3801 5.70419 21.1679 5.83878 21.0352L12.7308 13.9757C13.0566 13.6408 13.5241 13.4684 14.0023 13.4916C14.4839 13.5181 14.9231 13.7403 15.2064 14.105L22.9732 24.0759C23.0901 24.2251 23.0547 24.4307 22.8953 24.5401C22.828 24.5832 22.7572 24.6031 22.6828 24.6031Z" fill="black" />
                        <path d="M18.3513 19.0384C18.2557 19.0384 18.1636 19.002 18.0928 18.9356C17.9582 18.803 17.9653 18.5908 18.1069 18.4681L21.9036 15.1257C22.2577 14.814 22.7323 14.6714 23.214 14.7311C23.6921 14.7908 24.1136 15.0461 24.365 15.4307L26.2031 18.226C26.3058 18.3819 26.2527 18.5875 26.0862 18.6836C25.9198 18.7798 25.7002 18.7301 25.5975 18.5742L23.7594 15.7789C23.6177 15.5634 23.384 15.4208 23.1148 15.3876C22.8456 15.3545 22.58 15.4341 22.3852 15.6065L18.5957 18.9489C18.5248 19.0086 18.4398 19.0384 18.3513 19.0384Z" fill="black" />
                        <path d="M18.3512 24.6031C18.2591 24.6031 18.1671 24.57 18.0998 24.5037L13.4248 20.0637C13.0777 19.7321 12.511 19.6923 12.1144 19.9675L6.46546 23.8803C6.30963 23.9897 6.08651 23.9565 5.96963 23.8106C5.85276 23.6647 5.88463 23.4558 6.04401 23.3464L11.6929 19.4337C12.3729 18.9628 13.3362 19.0324 13.9312 19.5961L18.6062 24.0361C18.7443 24.1654 18.7408 24.3777 18.6027 24.5037C18.5318 24.57 18.4398 24.6031 18.3512 24.6031Z" fill="black" />
                        <path d="M18.7551 12.3808C17.6253 12.3808 16.708 11.522 16.708 10.4642C16.708 9.40642 17.6253 8.54761 18.7551 8.54761C19.8849 8.54761 20.8021 9.40642 20.8021 10.4642C20.8021 11.522 19.8813 12.3808 18.7551 12.3808ZM18.7551 9.21079C18.0184 9.21079 17.4163 9.77117 17.4163 10.4642C17.4163 11.1539 18.0149 11.7176 18.7551 11.7176C19.4953 11.7176 20.0938 11.1572 20.0938 10.4642C20.0903 9.77449 19.4917 9.21079 18.7551 9.21079Z" fill="black" />
                      </svg>

                    </span>
                    <span className='sidebar-nav-link-text'>Creatives</span>
                  </NavLink>
                  {['Paid', 'Paid + Barter'].includes(props.selectCampaign.campaign_type) &&
                    <NavLink className="sidebar-nav-link" to={`sendinvoice?${params}`}>
                      <span className='sidebar-nav-link-icon'>
                        <svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.371 23.3334L1.7339 14.3576V12.6539H5.87492C7.34667 12.6539 8.68297 12.1906 9.8838 11.2641C11.0846 10.3375 11.696 8.98451 11.7177 7.2052H0.208252V6.00648H11.6397C11.3739 4.80595 10.7072 3.81564 9.63953 3.03556C8.57189 2.25549 7.31701 1.86546 5.87492 1.86546H0.208252V0.666748H15.7916V1.86546H9.94876C10.6934 2.27773 11.3288 2.86559 11.8549 3.62903C12.381 4.39245 12.7137 5.18493 12.8529 6.00648H15.7916V7.2052H12.9011C12.8938 9.25816 12.187 10.8793 10.7806 12.0686C9.37422 13.258 7.73899 13.8527 5.87492 13.8527H2.93353L12.0247 23.3334H10.371Z" fill="#1C1B1F" />
                        </svg>

                      </span>
                      <span className='sidebar-nav-link-text'>Send Invoice</span>
                    </NavLink>
                  }
                {
                  (() => {
                    if (tokenParams == null && props.UserReducer !==null) {
                      return (
                        <>
                  <NavLink className="sidebar-nav-link" to={`analytics?${params}`}>
                    <span className='sidebar-nav-link-icon'>
                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.8125 24.0416V22.2563L1.97596 21.0576V24.0416H0.8125ZM6.3742 24.0416V16.5896L7.53766 15.3909V24.0416H6.3742ZM11.9183 24.0416V15.3909L13.0817 16.625V24.0416H11.9183ZM17.48 24.0416V16.625L18.6434 15.4263V24.0416H17.48ZM23.024 24.0416V10.923L24.1875 9.72425V24.0416H23.024ZM0.8125 15.3809V13.7109L9.75 4.51343L15.25 10.1801L24.1875 0.966309V2.65451L15.25 11.8683L9.75 6.20163L0.8125 15.3809Z" fill="#1C1B1F" />
                      </svg>

                    </span>
                    <span className='sidebar-nav-link-text'>Analytics</span>
                  </NavLink>                        
                  </>
                      );
                    }
                  })()
                }


                </nav>
              )}
            </div>
            <div className="col main-container">
              <Outlet />
            </div>
          </div>
          {selectedCampaign !== null && (
            <CustomDrawer
            open={!!campaignPopperState[selectedCampaign.campaign_id]}
            onClose={handleCustomDrawerClose}
            drawerTitle='Share'
            className="share-drawer"
          >
            <div className='custom-drawer-body'>
              <div className='share-sec-container'>
                <div className='share-icons'>
                  <TwitterShareButton
                    url={shareUrl}
                    className='Demo__some-network__share-button'
                  >
                    <XIcon size={24} round={true} />
                    <span className='share-titles'>X</span>
                  </TwitterShareButton>
                </div>
                <div className='share-icons'>
                  <FacebookShareButton
                    url={shareUrl}
                    className='Demo__some-network__share-button'
                  >
                    <FacebookIcon style={{ color: '#1877F2' }} />
                    <span className='share-titles'>Facebook</span>
                  </FacebookShareButton>
                </div>
                <div className='share-icons'>
                  <WhatsappShareButton
                    url={shareUrl}
                    className='Demo__some-network__share-button'
                  >
                    <WhatsAppIcon style={{ color: '#25D366' }} />
                    <span className='share-titles'>WhatsApp</span>
                  </WhatsappShareButton>
                </div>
                <div className='share-icons' style={{ color: '#00aae5' }}>
                  <button type='button' onClick={() => copyToClipboard()}>
                    <ContentCopyIcon />
                    <span className='share-titles'>Copy Link</span>
                  </button>
                </div>
              </div>
            </div>
          </CustomDrawer>
          )}
          {/* {selectedCampaign && (
            <Popper
              open={campaignPopperState[selectedCampaign.campaign_id]}
              anchorEl={anchorEls}
              placement='bottom-end'
              className='infl-dashboard-share'
            >
              <Box
              >
                <div className='share-icons'>
                  <TwitterShareButton
                    url={shareUrl}
                    className='Demo__some-network__share-button'
                  >
                    <XIcon size={24} round={true} />
                    <span className='share-titles'>X</span>
                  </TwitterShareButton>
                </div>
                <div className='share-icons'>
                  <FacebookShareButton
                    url={shareUrl}
                    className='Demo__some-network__share-button'
                  >
                    <FacebookIcon style={{ color: '#1877F2' }} />
                    <span className='share-titles'>Facebook</span>
                  </FacebookShareButton>
                </div>
                <div className='share-icons'>
                  <WhatsappShareButton
                    url={shareUrl}
                    className='Demo__some-network__share-button'
                  >
                    <WhatsAppIcon style={{ color: '#25D366' }} />
                    <span className='share-titles'>WhatsApp Web</span>
                  </WhatsappShareButton>
                </div>
                <div className='share-icons' style={{ color: '#00aae5' }}>
                  <ContentCopyIcon />
                  <span
                    className='share-titles'
                    onClick={() =>
                      copyToClipboard()
                    }
                  >
                    Copy Link
                  </span>
                </div>
              </Box>
            </Popper>
          )} */}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
    selectCampaign: state.InfSelectCamp.campaign,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
    selectedInf: (data: any) => dispatch(SelectedCampaign(data)),
  };
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(InfluencerMainCampDetail);

export { connectToRedux as InfluencerMainCampDetail };
